import { UPDATE_AUTH_USER, UPDATE_LOAD_USER, UPDATE_PHONE } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  authUser: null,
  loadUser: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_AUTH_USER: {
      return {
        ...state,
        authUser: action.payload,
        loadUser: true,
      };
    }
    case UPDATE_LOAD_USER: {
      return {
        ...state,
        loadUser: action.payload,
      };
    }
    case UPDATE_PHONE: {
      return {
        ...state,
        authUser: {
          ...state.authUser,
          phoneNumber: action.phoneNo,
        },
      };
    }

    default:
      return state;
  }
};
